/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 14:50:09
 * @LastEditTime : 2020-01-15 16:05:48
 * @LastEditors  : Please set LastEditors
 */
export default {
  /**
   * 对象转url参数
   * @param {*} data
   * @param {*} isPrefix
   */
  urlEncode (data, isPrefix = true) {
    let prefix = isPrefix ? '?' : '';
    let _result = [];
    for (let key in data) {
      let value = data[key];
      // 去掉为空的参数
      if (['', undefined, null].includes(value)) {
        continue;
      }
      if (value.constructor === Array) {
        value.forEach(_value => {
          _result.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(_value));
        });
      } else {
        _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
    console.log('prefix + _result.join', prefix + _result.join('&'));
    return _result.length ? prefix + _result.join('&') : '';
  },
  /**
   * @description:深度拷贝对象
   * @param {Object} obj
   * @returns {Object} 拷贝后的对象
   */
  deepCloneObj (obj) {
    let proto = Object.getPrototypeOf(obj);
    return Object.assign({}, Object.create(proto), obj);
  },
  /**
   * @description: 角度转文字
   * @param {Number} angle
   * @return {String}  文字提示
   */
  angleToText (angle) {
    let obj = {};
    if ((angle >= 0 && angle <= 20) || (angle > 340 && angle < 360)) {
      obj.tipMsg = '直行';
      obj.icon = 'front';
    } else if (angle > 20 && angle <= 45) {
      obj.tipMsg = '右前方直行';
      obj.icon = 'right-front';
    } else if (angle > 45 && angle <= 135) {
      obj.tipMsg = '右转';
      obj.icon = 'right';
    } else if (angle > 135 && angle <= 180) {
      obj.tipMsg = '前方往右后方转';
      obj.icon = 'right-rear';
    } else if (angle > 180 && angle <= 225) {
      obj.tipMsg = '前方往左后方转';
      obj.icon = 'left-rear';
    } else if (angle > 225 && angle <= 315) {
      obj.tipMsg = '左转';
      obj.icon = 'left';
    } else if (angle > 315 && angle <= 340) {
      obj.tipMsg = '左前方直行';
      obj.icon = 'left-front';
    }
    return obj;
  },
  /**
   * @description: 文字转语音
   * @param {String} str 文字
   */
  voiceText (str, token, isPlay = true) {
    if (!isPlay) { return new Promise((resolve, reject) => { resolve(null) ; }) ; }

    const audioUrl = 'https://tsn.baidu.com/text2audio';
    const audioTxt = encodeURI(encodeURI(str));
    let audio;

    return new Promise((resolve, reject) => {
      let url = `${audioUrl}?lan=zh&cuid=0&ctp=1&tok=${token}&tex=${audioTxt}`;
      audio = new Audio(url);
      audio.src = url;
      audio.play();
      resolve(audio);
    });
  },
  /**
   * @description: 获取两点间距离
   * @param {Object}
   * @return 距离长度
   */
  getTwoPointsDistance (point1, point2) {
    return Math.sqrt(Math.pow((point2.x - point1.x), 2) + Math.pow((point2.y - point1.y), 2));
  },

  /**
   * 函数节流
   * @param {Function} func 方法
   * @param {Number} limit 节流间隔
   */
  throttle (func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => { inThrottle = false }, limit);
      }
    }
  },
  /**
   * 函数防抖
   * @param {Function} method 方法
   * @param {Number} delay
   */
  debounce (func, wait = 500) {
    // 这个定时器一定不能是这个函数私有的，一定是要放在Data中，如果
    // 没有放在data中则会出现点击几次就触发几次，虽然说点击后确实会延迟执行，但是没有起到节流应该有的效果
    // let timer = this.timer
    // debugger
    // 这里返回的函数是每次用户实际调用的防抖函数
    // 如果已经设定过定时器了就清空上一次的定时器
    // 开始一个新的定时器，延迟执行用户传入的方法
    // 这里的this一定要保存副本！！！！！！
    let _this = this;
    return function (...args) {
      if (_this.timer) clearTimeout(_this.timer);
      // console.log('77')
      _this.timer = setTimeout(() => {
        func.apply(_this, args);
      }, wait);
    };
  },
  // 去除标点符号
  delSymbol (str) {
    str = str.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?|\，|\。|\“|\”|\；|\：|\’|\‘|\？|\、]/g, '');
    return str;
  },
  /**
   * 将对象数组按某一属性x分层
   * @param {*} arr 对象数组
   * @param {*} propertyName 属性名
   * return [...{floor:x,data:[]}]
   */
  partition (arr, propertyName) {
    let objArr = [];
    let obj = {};
    let startIndex = 0;
    let property = null;
    arr.forEach((item, index) => {
      if (property === null) {
        property = item[propertyName];
      }
      if (item[propertyName] !== property) {
        obj = {};
        obj[propertyName] = property;
        obj['data'] = arr.slice(startIndex, index);
        objArr.push(obj);
        startIndex = index;
        property = item[propertyName];
      }
      if (index === arr.length - 1) {
        obj = {};
        obj[propertyName] = property;
        obj['data'] = arr.slice(startIndex);
        objArr.push(obj);
      }
    });
    return objArr;
  },
  /**
   * 路径数据转化
   * @param {Array} routeData 路径数据
   * @param {Number} sectionLength 分段长度
   * @param {Array} floorMapping 楼层映射关系
   */
  routeDataTransform (routeData, sectionLength, floorMapping) {
    const ROUTE_TYPE = { 1: '乘电梯到', 10: '乘扶梯上', 12: '乘扶梯下', 20: '走楼梯上', 21: '走楼梯下' };// 路径类型

    let routeDataPartition = this.partition(routeData, 'floor');// 路径数据按顺序分层
    let nodeIndex = 0; // 节点下标

    console.log('路径分层：', routeDataPartition);
    routeDataPartition = routeDataPartition.filter((item, index) => {
      return item['data'].length > 1 || index === routeDataPartition.length - 1 || index === 0;
    });
    let routeDataPartitionTotal = routeDataPartition.length;// 路径分层总数
    console.log('过滤路径分层：', routeDataPartition);

    // 遍历路径分层数据，为每层路径添加信息
    routeDataPartition.forEach((item, index) => {
      let curFloorRouteData = item.data; // 当前楼层路径数据
      let curFloorRouteDataLength = curFloorRouteData.length; // 当前楼层路径数据长度

      // 计算下一个目的地是几楼
      let next = null;
      let fangxiang = null;
      for (let i = index + 1; i < routeDataPartitionTotal; i++) {
        if (fangxiang === null) {
          fangxiang = routeDataPartition[i].floor > routeDataPartition[i - 1].floor;
          next = routeDataPartition[i].floor;
        } else if ((routeDataPartition[i].floor > routeDataPartition[i - 1].floor) !== fangxiang) {
          next = routeDataPartition[i - 1].floor;
          fangxiang = routeDataPartition[i].floor > routeDataPartition[i - 1].floor;
          break;
        } else {
          next = routeDataPartition[i].floor;
        }
      }
      console.log('nextFloor:', next);

      // 为当前楼层路径数据每个点添加角度，即方向
      for (let i = 0; i < curFloorRouteDataLength; i++) {
        if (i === curFloorRouteDataLength - 1) break;
        let curNode = curFloorRouteData[i];
        let nextNode = curFloorRouteData[i + 1];
        let angle = Math.atan2((nextNode.y - curNode.y), (nextNode.x - curNode.x)) * (180 / Math.PI);
        curNode.angle = angle;
      }
      // 路径分段
      let routeDataSection = [];
      for (let i = 0; i < curFloorRouteDataLength; i++) {
        routeDataSection.push(curFloorRouteData[i]);
        if (i === curFloorRouteDataLength - 1) break;
        let cur = curFloorRouteData[i];
        let next = curFloorRouteData[i + 1];
        let diffX = next.x - cur.x;
        let diffY = next.y - cur.y;
        let distance = this.getTwoPointsDistance(cur, next);
        let sectionTotal = Math.round(distance / sectionLength);
        let incX = diffX / sectionTotal;
        let incY = diffY / sectionTotal;
        for (let j = 1; j < sectionTotal; j++) {
          let obj = {
            x: cur.x,
            y: cur.y,
            floor: cur.floor,
            angle: cur.angle
          };
          obj.x += j * incX;
          obj.y += j * incY;
          routeDataSection.push(obj);
        }
      }
      // 为每个节点添加下标，标识该点处于路径上第几个
      routeDataSection.forEach(item => {
        item.index = nodeIndex;
        item.nextFloor = next;// 添加下一楼层属性
        nodeIndex++;
      });
      // 为节点添加文字提示
      let routeDataSectionLength = routeDataSection.length;
      let node_i = [];
      let node_j = null;
      let distance = null;
      let angleTipObj = null;
      let isSpeakArr = [];
      for (let i = 0; i < routeDataSectionLength; i++) {
        node_i = routeDataSection[i];
        for (let j = i + 1; j < routeDataSectionLength; j++) {
          node_j = routeDataSection[j];
          if (Math.abs(node_j.angle - node_i.angle) > 10) {
            distance = this.getTwoPointsDistance({ x: node_i.x, y: node_i.y }, { x: node_j.x, y: node_j.y });
            distance = Math.round(distance);
            if (distance <= 5) {
              angleTipObj = this.angleToText((360 + node_i.angle - node_j.angle) % 360);
              node_i.text = distance + '米后' + angleTipObj.tipMsg;
              node_i.icon = angleTipObj.icon;
              if (isSpeakArr.indexOf(j) === -1) {
                node_i.isSpeak = true;
                isSpeakArr.push(j);
              }
            } else {
              node_i.text = '请直行' + distance + '米';
              node_i.icon = 'front';
            }
            break;
          }
        }
        console.log('特殊处理');
        // 最后一段路是直行的，没有拐弯点，所以没有赋值到方向提示(text属性)，需要做特殊处理
        if (!node_i.text) {
          let curFloorEndNode = routeDataSection[routeDataSectionLength - 1];
          distance = this.getTwoPointsDistance({ x: node_i.x, y: node_i.y }, { x: curFloorEndNode.x, y: curFloorEndNode.y });
          distance = Math.round(distance);
          if (distance <= 5) {
            // 如果当前不是路径规划最后一层
            if (index !== routeDataPartitionTotal - 1) {
              let nextFloor = next;
              let showFloor = floorMapping ? floorMapping[nextFloor - 1] : nextFloor;
              // node_i.text = distance + '米后,' + ROUTE_TYPE[curFloorEndNode.type] + showFloor + '层';
              node_i.text = `${distance}米后，${curFloorEndNode.type ? ROUTE_TYPE[curFloorEndNode.type] : '沿路线到'}${showFloor}层`;
            } else {
              node_i.text = distance + '米后到达终点';
            }
          } else {
            node_i.text = '请直行' + distance + '米';
          }
          node_i.icon = 'front';
        }
      }

      console.log('楼层提示处理');
      for (let i = 0; i < routeDataSectionLength; i++) {
        let curNode = routeDataSection[i];
        let nextNode = routeDataSection[i + 1];
        let curFloorEndNode = routeDataSection[routeDataSectionLength - 1];
        if (i === routeDataSectionLength - 1) {
          if (index !== routeDataPartitionTotal - 1) {
            let nextFloor = next;
            let showFloor = floorMapping ? floorMapping[nextFloor - 1] : nextFloor;
            // node_i.text = '请' + ROUTE_TYPE[curFloorEndNode.type] + showFloor + '层';
            node_i.text = `请${curFloorEndNode.type ? ROUTE_TYPE[curFloorEndNode.type] : '沿路线到'}${showFloor}层`;
          } else {
            curNode.text = '到达终点';
          }
          break;
        }

        if (Math.abs(curNode.angle - nextNode.angle) > 10) {
          let obj = this.angleToText((360 + curNode.angle - nextNode.angle) % 360);
          nextNode.text = obj.tipMsg;
          nextNode.icon = obj.icon;
          nextNode.isSpeak = false;
        }
      }

      curFloorRouteData[curFloorRouteDataLength - 1].isSpeak = true;
      routeDataPartition[index]['data'] = routeDataSection;
      console.table(routeDataSection);
    });

    return routeDataPartition;
  },

  // 处理比例尺数据
  setMapScale (mapscale) {
    mapscale = Math.ceil(mapscale / 100);
    if (mapscale > 361) {
      mapscale = 500;
    } else if (mapscale > 180.56) {
      mapscale = 200;
    } else if (mapscale > 90.82) {
      mapscale = 100;
    } else if (mapscale > 45.14) {
      mapscale = 50;
    } else if (mapscale > 35.14) {
      mapscale = 40;
    } else if (mapscale > 22.57) {
      mapscale = 30;
    } else if (mapscale > 11.28) {
      mapscale = 20;
    } else if (mapscale > 5.64) {
      mapscale = 10;
    } else if (mapscale > 2.82) {
      mapscale = 5;
    } else if (mapscale > 1.14) {
      mapscale = 2;
    } else if (mapscale > 0.70) {
      mapscale = 1;
    } else {
      mapscale = 1;
    }
    return mapscale;
  },
  // js简单取词器
  /**
   * js简单取词器
   * @param {Function} method 方法
   * @param {Array} dictArr 提词字典，
   * @param {String} string 需要提取的词
   */
  translateChiese (dictArr, string) {
    // 字典
    let dict = dictArr;
    // 停止词
    let stop = {
      '的': 1
    };
    // 待分词的字符串
    // let words = 'hello, kitty!我的家乡在松花江边上，那里有四季迷人的花香。fine~';
    let words = string;

    // Trie树
    function Trie () {
      this.root = new Node(null);
    }
    Trie.prototype = {
    /**
    * 将Unicode转成UTF8的三字节
    */
      toBytes: function (word) {
        let result = [];
        for (let i = 0; i < word.length; i++) {
          let code = word.charCodeAt(i);
          // 单字节
          if (code < 0x80) {
            result.push(code);
          } else {
          // 三字节
            result = result.concat(this.toUTF8(code));
          }
        }

        return result;
      },
      toUTF8: function (c) {
      // 1110xxxx 10xxxxxx 10xxxxxx
      // 1110xxxx
        let byte1 = 0xE0 | ((c >> 12) & 0x0F);
        // 10xxxxxx
        let byte2 = 0x80 | ((c >> 6) & 0x3F);
        // 10xxxxxx
        let byte3 = 0x80 | (c & 0x3F);

        return [byte1, byte2, byte3];
      },
      toUTF16: function (b1, b2, b3) {
      // 1110xxxx 10xxxxxx 10xxxxxx
        let byte1 = (b1 << 4) | ((b2 >> 2) & 0x0F);
        let byte2 = ((b2 & 0x03) << 6) | (b3 & 0x3F);
        let utf16 = ((byte1 & 0x00FF) << 8) | byte2;

        return utf16;
      },
      /**
    * 添加每个词到Trie树
    */
      add: function (word) {
        let node = this.root; let bytes = this.toBytes(word); let len = bytes.length;
        for (let i = 0; i < len; i++) {
          let c = bytes[i];
          // 如果不存在则添加，否则不需要再保存了，因为共用前缀
          if (!(c in node.childs)) {
            node.childs[c] = new Node(c);
          }
          node = node.childs[c];
        }
        node.asWord(); // 成词边界
      },
      /**
    * 按字节在Trie树中搜索
    */
      search: function (bytes) {
        let node = this.root; let len = bytes.length; let result = [];
        let word = []; let j = 0;
        for (let i = 0; i < len; i++) {
          let c = bytes[i]; let childs = node.childs;
          if (!(c in childs)) {
            return result;
          }

          if (c < 0x80) {
            word.push(String.fromCharCode(c));
          } else {
            j++;
            if (j % 3 === 0) {
              let b1 = bytes[i - 2];
              let b2 = bytes[i - 1];
              let b3 = c;
              word.push(String.fromCharCode(this.toUTF16(b1, b2, b3)));
            }
          }
          // 如果是停止词，则退出
          if (word.join('') in stop) {
            return result;
          }

          // 成词
          let cnode = childs[c];
          if (cnode.isWord()) {
            cnode.addCount(); // 用于计数判断
            result.push(word.join(''));
          }

          node = cnode;
        }
        return result;
      },
      /**
    * 分词
    */
      splitWords: function (words) {
      // 转换成单字节进行搜索
        let bytes = this.toBytes(words);
        let start = 0; let end = bytes.length - 1; let result = [];

        while (start !== end) {
          let word = [];
          for (let i = start; i <= end; i++) {
            let b = bytes[i]; // 逐个取出字节
            word.push(b);

            let finds = this.search(word);
            if (finds !== false && finds.length > 0) {
            // 如果在字典中，则添加到分词结果集
              result = result.concat(finds);
            }
          }

          start++;
        }

        return result;
      },
      /**
    * 词始化整棵Trie树
    */
      init: function (dict) {
        for (let i = 0; i < dict.length; i++) {
          this.add(dict[i]);
        }
      }
    };

    // 节点
    function Node (_byte) {
      this.childs = {}; // 子节点集合
      this._byte = _byte || null; // 此节点上存储的字节
      this._isWord = false; // 边界保存，表示是否可以组成一个词
      this._count = 0;
    }
    Node.prototype = {
      isWord: function () {
        return (this._isWord && (this._count === 0));
      },
      asWord: function () {
        this._isWord = true;
      },
      addCount: function () {
        this._count++;
      },
      getCount: function () {
        return this._count;
      }
    };

    let trie = new Trie();
    trie.init(dict);
    let result = trie.splitWords(words);

    console.group('Trie 分词: ');
    console.log('待分词的字符串: ', words);
    console.log('分词结果:', result);
    console.groupEnd();
    return result;
  },
  // 计算两个角度差
  anglediff (a, b, abs = true) {
    let d1, d2;
    d1 = a - b;
    d2 = 360 - Math.abs(d1);
    if (d1 > 0) {
      d2 *= -1;
    }
    if (Math.abs(d1) < Math.abs(d2)) {
      return abs ? Math.abs(d1) : d1;
    } else {
      return abs ? Math.abs(d2) : d2;
    }
  },
  /**
 *
 * @param lat1  纬度1
 * @param lng1  经度1
 * @param lat2  纬度2
 * @param lng2  经度2
 */
  // 根据两点之间的经纬度查询距离
  GetDistance (lat1, lng1, lat2, lng2) {
    let radLat1 = lat1 * Math.PI / 180.0;
    let radLat2 = lat2 * Math.PI / 180.0;
    let a = radLat1 - radLat2;
    let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137 ;// EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;
    return s;
  },
  /**
  @function     JsonSort 对json排序
  @param        json     用来排序的json
  @param        key      排序的键值
*/
  // key值应为数字类型
  JsonSort (json, key) {
    for (let j = 1, jl = json.length;j < jl;j++) {
      let temp = json[j];
      let val = temp[key];
      let i = j - 1;
      while (i >= 0 && json[i][key] > val) {
        json[i + 1] = json[i];
        i = i - 1;
      }
      json[i + 1] = temp;
    }
    return json;
  },
  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02tobd09 (lng, lat) {
    // let that = this;
    let x_PI = 3.14159265358979324 * 3000.0 / 180.0;
    // let PI = 3.1415926535897932384626;
    // let a = 6378245.0;
    // let ee = 0.00669342162296594323;
    let z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    let theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    let bd_lng = z * Math.cos(theta) + 0.0065;
    let bd_lat = z * Math.sin(theta) + 0.006;
    // return [bd_lng, bd_lat];
    return {
      latitude: bd_lat,
      longitude: bd_lng
    };
  },
  /**
 * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
 * 即 百度 转 谷歌、高德
 * @param bd_lon
 * @param bd_lat
 * @returns {*[]}
 */
  bd09togcj02 (bd_lon, bd_lat) {
    let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
    let x = bd_lon - 0.0065;
    let y = bd_lat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    let gg_lng = z * Math.cos(theta);
    let gg_lat = z * Math.sin(theta);
    return [gg_lng, gg_lat];
  },
  /**
 * 格式化接口返回数据
 * @param {*} data
 * @param {*} type 在格式化出错时，为type=1，返回{}，否则返回[]
 */
  formatHttpData (data, type) {
    try {
      return JSON.parse(data);
    } catch (e) {
      if (type && type === 1) {
        return {};
      } else {
        return [];
      }
    }
  },
  getLocation () { // 检测是否支持地理定位 如果支持，则运行 getCurrentPosition() 方法。如果不支持，则向用户显示一段消息。
    if (navigator.geolocation) { // 如果getCurrentPosition()运行成功， //则向参数showPosition中规定的函数返回一个coordinates对象
      navigator.geolocation.getCurrentPosition((position) => {
        console.log('输出定位');
        console.log(position);
        return position;
        // this.lon = position.coords.longitude;
        // this.lat = position.coords.latitude;
      }, error => {
        console.log('error');
        console.log(error);
        switch (error.code) {
          case 1:
            this.$message({
              showClose: true,
              message: '地理位置信息的获取失败，因为该页面没有获取地理位置信息的权限。',
              type: 'error'
            });
            // alert('地理位置信息的获取失败，因为该页面没有获取地理位置信息的权限。');
            break;
          case 2:
            this.$message({
              showClose: true,
              message: '地理位置获取失败，因为至少有一个内部位置源返回一个内部错误。',
              type: 'error'
            });
            // alert('地理位置获取失败，因为至少有一个内部位置源返回一个内部错误。');
            break;
          case 3:
            this.$message({
              showClose: true,
              message: '获取地理位置的超时时长。',
              type: 'error'
            });
            // alert('获取地理位置的超时时长。');
            break;
          default:
            this.$message({
              showClose: true,
              message: '地理位置信息的获取失败，因为该页面没有获取地理位置信息的权限。',
              type: 'error'
            });
            // alert('地理位置信息的获取失败，因为该页面没有获取地理位置信息的权限。');
        }
      });
    } else {
      this.$message({
        showClose: true,
        message: '对不起，您的浏览器不支持地理位置定位',
        type: 'error'
      });
      // alert('对不起，您的浏览器不支持地理位置定位');
    }
  }
};

